const PriceModal = ({ filters, setFilters, onClose }) => {
  const value = filters.price != null && filters.price !== "" ? Number(filters.price) : "";

  return (
    <div className="w-full relative">
      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>
      <h2 className="lg:text-xl text-lg font-semibold mb-4">Max Price ($)</h2>

      <input
        type="number"
        min={0}
        placeholder="e.g. 500"
        value={value}
        onChange={(e) => {
          const v = e.target.value;
          setFilters({
            ...filters,
            price: v === "" ? null : (Number(v) || 0)
          });
        }}
        className="w-full border rounded-xl px-4 py-3 lg:text-base text-sm"
      />

      {/* Actions */}
      <div className="flex justify-between items-center">
        <button
          onClick={() => {
            setFilters({ ...filters, price: null });
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>

        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-6 py-2.5 mt-2 rounded-lg text-sm font-medium hover:bg-orange-600 transition"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default PriceModal;
